import styled from 'styled-components';
import { Popover } from '@mui/material';

export const ConditionContainer = styled.div`
  display: flex;
  padding: 8px 16px;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.grey[100]};
`;

export const ConditionText = styled.p`
  min-width: 32px;
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  margin: auto;
  white-space: nowrap;
`;

export const FieldLabel = styled.p`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 12px;
  font-weight: 400;
  margin: 0;
`;

export const SectionContainer = styled.div`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
  margin: 6px 0;
  background-color: ${({ theme }) => theme.palette.common.white};

  &:hover {
    .sectionHeader {
      background-color: ${({ theme }) => theme.palette.grey[200]};
    }
  }
`;

export const Header = styled.div<{ $expanded: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: ${({ $expanded, theme }) => ($expanded ? `1px solid ${theme.palette.grey[300]}` : 'none')};

  padding: 16px;
  cursor: pointer;
`;

export const SectionInformation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 90%;

  h1 {
    margin: 0;
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
  }

  p {
    margin: 0;
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 12px;
    font-weight: 400;
    line-height: 24px;
  }
`;

export const StyledPopover = styled(Popover)`
  box-shadow: none;
  border: none;
  border-radius: 8px;
`;

export const PipelinesInfoContainer = styled.div`
  display: flex;
  padding: 12px;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.common.white};

  p {
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.15px;
    margin: 0;
  }
`;
